<!-- 新闻动态 -->
<template>
	<div class="news" style="padding: 2rem 0;">
		<div class="container">
			<div class="news-list" id="newsList">
				<!-- <a v-for="item in arrData" :key="item.newsid" :href="'/news?newsid=' + item.newsid" target="_blank">
					<div class="news-list-item">
						<h3 class="news-title">{{item.title}}</h3>
						<p class="news-synopsis">{{item.synopsis}}</p>
						<p class="news-time">文章来源：<span>{{item.source}}</span><span>{{item.time}}</span></p>
					</div>
				</a> -->
				<router-link v-for="item in arrCurrData" :key="item.newsid" tag="a" target="_blank" :to="{name:'news', query: { newsid: item.newsid }}">
					<div class="news-list-item">
						<h3 class="news-title">{{item.title}}</h3>
						<p class="news-synopsis">{{item.synopsis}}</p>
						<p class="news-time">文章来源：<span>{{item.source}}</span><span>{{item.time}}</span></p>
					</div>
				</router-link>
			</div>
			<!-- 分页  带背景，只有一页隐藏，带有控件，每页显示条数，数据总条数  -->
			<el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="len" :total="arrData.length"
			 @current-change="ChangePagination" style="text-align: right;"></el-pagination>
		</div>
	</div>
</template>

<script>
	// import arrNews from '../assets/news/news2020.json';
	export default {
		name: "NewsList",
		data() {
			return {
				curr: 0, //开始索引
				len: 10, //每页条数
				arrData: [], //可显示的新闻总数
				arrCurrData: [] //当前页新闻数
			}
		},
		mounted: function() {
			//获取新闻列表
			this.$axios.get('/new/list').then(res => {
					if(res.status==200 && res.data) {
						this.arrData = res.data.filter(function(item, index) {
							return item.isshow; //允许显示和在首页显示的
						});
						this.arrCurrData = this.arrData.slice(0, this.len); //默认第一页显示数据
					} else {
						this.$message('新闻列表获取失败！');
					}
				})
				.catch(function(error) {
					//获取失败
					console.log(error);
				})
				.finally(function() {
					// always executed
				});
			// const arrNews = require('../assets/news/news2018.json');
			// this.arrData = arrNews.filter(function(item, index) {
			// 	return item.isshow; //允许显示和在首页显示的
			// });
			// this.arrCurrData = this.arrData.slice(0, this.len); //默认第一页显示数据
		},
		methods: {
			//切换分页
			ChangePagination(curr) {
				if (this.curr != curr - 1) {
					this.curr = curr - 1;
					this.arrCurrData = this.arrData.slice(this.curr, this.curr + this.len);
				}
			}
		}
	}
</script>

<style>
</style>
